import { Injectable } from '@angular/core';
import { AuthType } from "../models/auth-type.model";
import { CookieKeys } from "../models/cookie-keys.model";
import { environment } from "../../environments/environment";
import { CookieService } from "ngx-cookie-service";
import { RootDomainHelper } from "./aids/root-domain.helper";

@Injectable({
  providedIn: 'root'
})
export class CookieManagerService {
  cookieExpirationTime: number = environment.thirdPartyLogin.cookieExpirationTime;
  domainName: string = environment.thirdPartyLogin.domainName;

  constructor(
    private cookieService: CookieService,
    private rootDomainHelper: RootDomainHelper,
  ) {
  }

  getLoginUUIDForAuthType(type: string) {
    const key = this.getLoginUUIDKeyForAuthType(type);
    return this.cookieService.get(key);
  }

  getLoginUUIDKeyForAuthType(type: string): string {
    const environment: string = this.rootDomainHelper.getEnvironment();
    const cookieMap = {
      dev: {
        [AuthType.BIOMETRICS]: CookieKeys.BIOMETRICS_LOGIN_UUID_DEV,
        [AuthType.GOOGLE]: CookieKeys.GOOGLE_LOGIN_UUID_DEV
      },
      test: {
        [AuthType.BIOMETRICS]: CookieKeys.BIOMETRICS_LOGIN_UUID_TEST,
        [AuthType.GOOGLE]: CookieKeys.GOOGLE_LOGIN_UUID_TEST
      },
      prelive: {
        [AuthType.BIOMETRICS]: CookieKeys.BIOMETRICS_LOGIN_UUID_PRELIVE,
        [AuthType.GOOGLE]: CookieKeys.GOOGLE_LOGIN_UUID_PRELIVE
      },
      live: {
        [AuthType.BIOMETRICS]: CookieKeys.BIOMETRICS_LOGIN_UUID,
        [AuthType.GOOGLE]: CookieKeys.GOOGLE_LOGIN_UUID
      }
    };

    if (environment === "localhost") return null;

    const envKey = cookieMap[environment] ? environment : "live";
    return cookieMap[envKey]?.[type] ?? null;
  }

  deleteLoginUUIDForAuthType(type: string) {
    const key = this.getLoginUUIDKeyForAuthType(type);
    if (!key) return;

    this.cookieService.delete(key, "/", this.rootDomainHelper.getRootDomain());
  }

  saveLoginUUIDForAuthType(uuid: string, type: string) {
    const key = this.getLoginUUIDKeyForAuthType(type);
    if (!key) return;

    this.saveUUIDToCookie(key, uuid);
  }

  /**
   * Save the ThirdPartyUUID as a cookie
   */
  public saveUUIDToCookie(name: string, uuid: string): void {
    if (!name || !uuid) {
      console.error("UUID missing! Unable to save as cookie.");
      return;
    }
    this.cookieService.set(
      name,
      uuid,
      this.cookieExpirationTime,
      "/",
      this.domainName,
      false,
      "Strict",
    );
  }

}
